import _ from 'lodash';
import qs from 'querystring';
import uuid from 'node-uuid';
import url from 'url';
import 'whatwg-fetch';

const parsed_url = url.parse(window.location.href, true);
const format_path = path => path.replace(/\/+/g, '/').replace(/\/$/, '');

const default_policy = {
  routing: {
    inbound: {
      prefix: '',
      host: parsed_url.hostname,
      port: parsed_url.port,
      protocol: parsed_url.protocol.split(':')[0]
    }
  },
  security: {
    requirements: {
      authentication: false,
      entitlements: []
    }
  }
};

const get_policy = (spec, route) => {
  const parts = route.split('/');

  let policy = default_policy;
  while (parts.length > 0) {
    policy = _.defaultsDeep({}, policy, spec.policy);
    const next = parts.shift();
    spec = spec[next];
    if (!spec) {
      return policy;
    }
  }
  return policy;
};

const prepare = async (data, spec) => {
  data.id = uuid.v4();
  data.time = (new Date()).toISOString();

  data.query = _.pickBy(data.query, val => val !== undefined);
  data.headers = _.pickBy(data.headers, val => val !== undefined);
  if (data.body === undefined) {
    delete data.body;
  }

  if (spec) {
    get_route_policy(spec, data.route);
  }

  return data;
};

const submit = async data => {
  const query = Object.keys(data.query).length > 0 ? `?${qs.stringify(data.query)}` : '';
  const url = `${data.route}${query}`;

  const request = {
    method: data.method,
    headers: new Headers(data.headers || {}),
    mode: 'cors',
    credentials: 'include',
    cache: 'no-cache'
  };

  if (data.body) {
    const content_type = request.headers.get('content-type') || '';
    if (content_type.indexOf('application/json') !== -1) {
      request.body = JSON.stringify(data.body);
    }
    else {
      request.body = data.body;
    }
  }

  const init = (new Date()).toISOString();
  const start = Date.now();
  const response = await fetch(data.base_url + url, request);
  const end = Date.now();
  const resp_headers = {};
  for (const [name, value] of response.headers.entries()) {
    resp_headers[name] = value;
  }

  const response_info = {
    id: data.id,
    headers: resp_headers,
    status: response.status,
    time: init,
    elapsed: end - start
  };

  try {
    const content_type = response.headers.get('content-type') || '';
    if (content_type.indexOf('application/json') !== -1) {
      response_info.body = await response.json();
    }
    else {
      response_info.body = await response.text();
    }
  }
  catch(err) {
    // TODO: handle invalid response bodies
    log.warn(err);
  }

  return response_info;
};

export {
  default_policy,
  get_policy,
  prepare,
  submit
};
